<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="设备名称：" prop="device_name">
                <el-input v-model="model.device_name"></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="device_model">
                <el-input v-model="model.device_model"></el-input>
            </el-form-item>
            <el-form-item label="使用部位：" prop="part">
                <el-input v-model="model.part"></el-input>
            </el-form-item>
            <el-form-item label="数量：" prop="count">
                <el-input v-model.number="model.count"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'monthReportPersonAdd',
    mixins: [editutil],
    props: {
        data_id: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.model.month_report_id = this.data_id
                this.resetModel(this.form_name);
            }
        }
    },
    data() {
        return {
            model: {
                month_report_id: '',
                device_name: '',
                device_model: '',
                part: '',
                count: '',
                remark: '',
                order_index: '',
            },
            getObj:{
                url:'/api/admin/monthreport/deviceInfo',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                device_name: [
                    {required: true, message: '设备名称不能为空', trigger: 'blur'},
                ],
                device_model: [
                    {required: true, message: '型号不能为空', trigger: 'blur'}
                ],
                part: [
                    {required: true, message: '使用部位不能为空', trigger: 'blur'}
                ],
                count: [
                    {required: true, message: '数量不能为空', trigger: 'blur'},
                    {type: 'number', message: '数量必须是数字值', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/monthreport/saveDevice'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>